module.exports = __webpack_public_path__ + "img/1x.df08108.jpg";